import { useMutation } from 'react-query';
import { REPORT_SCOPE } from '../reportsApi';
import { ReportTypes } from 'lib/const/ReportData';
import { DATE_FORMAT } from '../repairOrders/const';
import dayjs from 'dayjs';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useTranslation } from 'react-i18next';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';

interface ISendReportData {
  url: string;
  from: Date;
  to: Date;
  range: string;
  receivers: string[];
  users?: string[];
  customer?: string;
  extraParams?: any;
  reportScope: REPORT_SCOPE;
  organizationId?: string | number;
  reports?: ReportTypes[];
}

const sendReportData = async ({
  url,
  from,
  to,
  range,
  receivers,
  users,
  customer,
  extraParams,
  reportScope = REPORT_SCOPE.RESELLER,
  organizationId,
  reports,
}: ISendReportData) => {
  const params = {
    to: dayjs(to).format(DATE_FORMAT),
    from: dayjs(from).format(DATE_FORMAT),
    range,
    users: (users || []).join(','),
    customer,
    reportScope,
    organizationId,
    timezoneOffset: new Date().getTimezoneOffset(),
    reports,
    ...extraParams,
  };
  const data = {
    receivers,
  };

  const response = await EXPRESS_API.post(`${url}/send`, data, {
    params,
  });

  return response.data;
};

interface ISendReport {
  onSuccess?: () => void;
}
export const useSendReportData = ({ onSuccess }: ISendReport) => {
  const { t } = useTranslation();
  const { showError } = useToastError();
  return useMutation(sendReportData, {
    onSuccess: () => {
      if (onSuccess) onSuccess();
      successToast({
        title: t('Your report is being processed and will be sent shortly'),
      });
    },
    onError: () => {
      showError(
        t(
          'An error occurred while trying to send the report. Please try again.'
        )
      );
    },
  });
};
